module.exports = __webpack_public_path__ + "static/media/QuizApp2.0013e403.png";